import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import staff2 from '../../../../images/staff/member_1.png';
import View from './../../../modal/menu/item/View';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import Drawer from '@mui/material/Drawer';
import DatePicker, { DateObject } from "react-multi-date-picker";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import StaffExit from "./../../../modal/hr_management/Manage_Staff/StaffExit";
import RoleTransfer from "./../../../modal/hr_management/Manage_Staff/RoleTransfer";
import { useNavigate } from "react-router-dom";

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Staff = () => {

    const navigate = useNavigate();
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [staff, setstaff] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [selectedStaff, setSelectedStaff] = useState(null);
    const imageBaseURL = baseURL.replace('/api', '');

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()))
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const fetchData = () => {
        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/managestaff`, { params: params })
            .then(response => {
                const result = response.data?.data;

                const processed = result.map(item => ({
                    ...item,
                    staff_image_url: item.staff_image_url ?? (item.staff_image ? `${imageBaseURL}/storage/${item.staff_image}` : null)
                }));

                setstaff(processed);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.error('Error fetching staff data!', error);
                setHasFetched(true);
            });
    };

    useEffect(() => {
        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/managestaff`, { params: params })
            .then(response => {
                const result = response.data?.data;

                const processed = result.map(item => ({
                    ...item,
                    staff_image_url: item.staff_image_url ?? (item.staff_image ? `${imageBaseURL}/storage/${item.staff_image}` : null)
                }));

                setstaff(processed);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.error('Error fetching staff data!', error);
                setHasFetched(true);
            });
    }, [page, searchTerm, perPage]);

    const tableRef = useRef(null);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [filterName, setFilterName] = useState("");
    const [filterEmail, setFilterEmail] = useState("");
    const [filterMobile, setFilterMobile] = useState("");
    const [filterPosition, setFilterPosition] = useState("");
    const [filterDepartment, setFilterDepartment] = useState("all");

    const fetchStaffData = async () => {
        let params = {
            page,
            per_page: perPage,
            search: searchTerm,
            date_filter: date_fil_selt_value || '',
            branch_id: branch_id
        };
        if (date_fil_selt_value === 'custom') {
            params.start_date = custom_stdt_fil_value || '';
            params.end_date = custom_eddt_fil_value || '';
        }

        if (filterName) params.employee_name = filterName;
        if (filterEmail) params.mail_id = filterEmail;
        if (filterMobile) params.phone_no = filterMobile;
        if (filterPosition) params.position = filterPosition;
        if (filterDepartment !== "all") params.department_id = filterDepartment;
        if (selectedType === 0 && selectedOption?.value) {
            params.branch_id = selectedOption.value;
        }
        if (selectedType === 1 && selectedOption?.value) {
            params.franchise_id = selectedOption.value;
        }

        // if (date_fil_selt_value && date_fil_selt_value !== "all") {
        //     params.date_type = date_fil_selt_value;
        //     if (date_fil_selt_value === "today") {
        //         params.date_range = [new DateObject(today_fil_value).format("YYYY-MM-DD")];
        //     } else if (date_fil_selt_value === "this_week") {
        //         params.date_range = [
        //             new DateObject(week_stdt_fil_value).format("YYYY-MM-DD"),
        //             new DateObject(week_eddt_fil_value).format("YYYY-MM-DD"),
        //         ];
        //     } else if (date_fil_selt_value === "this_month") {
        //         const month = new DateObject(month_fil_value);
        //         const firstDay = new Date(month.year, month.month.number - 1, 1);
        //         const lastDay = new Date(month.year, month.month.number, 0);
        //         params.date_range = [
        //             new DateObject(firstDay).format("YYYY-MM-DD"),
        //             new DateObject(lastDay).format("YYYY-MM-DD"),
        //         ];
        //     } else if (date_fil_selt_value === "custom") {
        //         params.date_range = [
        //             new DateObject(custom_stdt_fil_value).format("YYYY-MM-DD"),
        //             new DateObject(custom_eddt_fil_value).format("YYYY-MM-DD"),
        //         ];
        //     }
        // }

        try {
            const response = await axios.get(`${baseURL}/managestaff`, { params });
            const result = response.data?.data || [];
            const processed = result.map(item => ({
                ...item,
                staff_image_url: item.staff_image_url ?? (item.staff_image ? `${imageBaseURL}/storage/${item.staff_image}` : null),
            }));
            setstaff(processed);
        } catch (error) {
            console.error("Error filtering staff:", error);
        } finally {
            setFilterOpen(false);
        }
    };

    // useEffect(() => {
    //     fetchStaffData();
    // }, []);

    const handleModalToggle = (staffItem) => {
        setSelectedStaff(staffItem)
        setModalType("View");
        setOpen(true);
    };

    const onClose = () => {
        setFilterOpen(false);
    };

    const DeleteModal = (staffItem) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Staff
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${staffItem.employee_name}</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/managestaff/${staffItem.sno}`)
                    .then(response => {
                        // Remove the deleted item from state
                        // setstaff(prev => prev.filter(b => b.sno !== staffItem.sno));
                        // swal.fire('Deleted!', 'Staff has been deleted.', 'success');
                        // window.location.reload();
                        toast.success("Staff Deleted Successfully!");
                        fetchData();
                    })
                    .catch(error => {
                        console.error("Error deleting branch:", error);
                        // swal.fire('Error', 'Something went wrong while deleting.', 'error');
                        toast.error("Staff Deletion Failed");
                    });
            }
        });
    };

    const handleStatusToggle = async (sno, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/managestaff/status/${sno}`, { status: newStatus })
            .then(response => {
                toast.success("Status Updated Successfully!");
                fetchData();
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Update Failed");
            });
    };

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const [departmentOptions, setDepartmentOptions] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/department/dropdown`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.department_name,
                }));
                const allOption = { value: null, label: "All" };
                setDepartmentOptions([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('Error fetching department options:', error);
            });
    }, []);

    const [selectedType, setSelectedType] = useState(0); // for "branch" or "franchise"
    const [selectedOption, setSelectedOption] = useState(null);
    const [branchOptions, setBranchOptions] = useState([]);
    const [franchiseOptions, setFranchiseOptions] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/managebranch/dropdown`)
            .then(response => {
                const data = response.data.data || [];
                const branches = data
                    .filter(item => item.manage_branch_type === 0)
                    .map(item => ({
                        value: item.sno,
                        label: item.branch_name,
                    }));
                const franchises = data
                    .filter(item => item.manage_branch_type === 1)
                    .map(item => ({
                        value: item.sno,
                        label: item.branch_name,
                    }));
                setBranchOptions(branches);
                setFranchiseOptions(franchises);
            })
            .catch(error => {
                console.error("Error fetching branch/franchise data", error);
            });
    }, []);

    const handleRadioChange = (event) => {
        const value = Number(event.target.value); // Convert to number
        setSelectedType(value);
        setSelectedOption(null);
    };

    const resetFilters = () => {
        // Reset basic filters
        setFilterName("");
        setFilterEmail("");
        setFilterMobile("");
        setFilterPosition("");
        setFilterDepartment("all");

        // Reset branch/franchise filter
        setSelectedType(0); // 0 = branch
        setSelectedOption(null);

        // Reset date filters
        setDateFilSeltValue("all");
        setTodayFilValue(new Date());
        setWeekSTDTFilValue(getStartOfWeek(new Date()));
        setWeekEDDTFilValue(getEndOfWeek(new Date()));
        setMonthFilValue(new Date());
        setCustomSTDTFilValue(new Date());
        setCustomEDDTFilValue(new Date());

        // Refetch all staff data with cleared filters
        fetchStaffData();

        // Optionally close the filter panel/modal
        setFilterOpen(false);
    };

    const [selecteddata, setSelecctedData] = useState({});
    const handleModalExit = (data) => {
        setSelecctedData(data);
        setModalType("Exit");
        setOpen(true);
    };

    const handleModalTransfer = (data) => {
        setSelecctedData(data);
        setModalType("Transfer");
        setOpen(true);
    };

    const [key, setKey] = useState('active_staff');

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Staff</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">HR Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3 mb-2'>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                    <Link to={"/add-staff"} className="btn btn-primary float-end btn-sm">
                        <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Staff</span>
                    </Link>
                    {open && modalType === "Exit" && (
                        <StaffExit show={open} onClose={() => setOpen(false)} data={selecteddata} refresh={fetchData} />
                    )}
                    {open && modalType === "Transfer" && (
                        <RoleTransfer show={open} onClose={() => setOpen(false)} data={selecteddata} refresh={fetchData} />
                    )}
                </div>
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="active_staff">
                                    <i className="fa-solid fa-users"></i>
                                    <label className="ms-2 fs-6">
                                        Active Staff
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-staff-exit">
                                    <i className="fa-solid fa-users-slash"></i>
                                    <label className="ms-2 fs-6">
                                        Exit Staff
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Tab.Container>
                </div>
            </Col>

            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{ fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{ fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-50px text-start'>Staff</th>
                            <th className='min-w-100px'>Email / Mobile</th>
                            <th className='min-w-100px'>Department / Postition</th>
                            <th className='min-w-50px'>Status</th>
                            <th className='min-w-100px'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {staff.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="5" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {staff.map((type, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={type.staff_image_url ? type.staff_image_url : staff2} className='border rounded px-1 py-0'>
                                                        <img src={type.staff_image_url ? type.staff_image_url : staff2} alt={type.employee_name} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>{type.employee_name}</label>
                                                    <div className="d-block">
                                                        <label className="fs-8 text-dark">{type.branch?.branch_name} {type.manage_staff_type_id === 0 ? "Branch" : "Franchise"}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{type.mail_id}</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-dark">{type.phone_no}</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{type.department?.department_name ?? 'N/A'}</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-dark">{type.position}</label>
                                            </div>
                                        </td>
                                        <td className='align-content-center'>
                                            <div className="form-check form-switch d-flex align-items-center mb-3">
                                                <input className="form-check-input me-2" type="checkbox" role="switch" checked={type.status === 0} onChange={() => handleStatusToggle(type.sno, type.status)} />
                                            </div>
                                        </td>
                                        <td className='align-content-center'>
                                            <div className="d-flex justify-content-start">
                                                {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                    <Link to={`/view-staff?data=${type.sno}`}>
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                            <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Link>
                                                </OverlayTrigger>

                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                    <Link to={`/edit-staff?data=${type.sno}`}>
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" >
                                                            <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Link>
                                                </OverlayTrigger> */}

                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Role Transfer</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalTransfer(type)}>
                                                        <span><i className="fa-solid fa-user-pen fs-6 mt-1"></i></span>
                                                    </Button>
                                                </OverlayTrigger>

                                                {type.exit_status === 0 && (
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Staff Exit</span></Tooltip>} >
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalExit(type)}>
                                                            <span><i className="fa-solid fa-right-from-bracket fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </OverlayTrigger>
                                                )}

                                                <Dropdown drop=''>
                                                    <Dropdown.Toggle as="a" className="i-false cursor-pointer">
                                                        <Button variant="primary tp-btn-light px-3 py-2">
                                                            <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item className='px-2 py-1' >
                                                            <Link to={`/view-staff?data=${type.sno}`}>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                        <span><i className="fa-solid fa-eye fs-5 mt-1 text-danger"></i></span>
                                                                    </div>
                                                                    <div className="ms-1 fs-7">View</div>
                                                                </div>
                                                            </Link>
                                                        </Dropdown.Item>

                                                        <Dropdown.Item className='px-2 py-1' >
                                                            <Link to={`/edit-staff?data=${type.sno}`}>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                        <span><i className="fa-solid fa-pen-to-square fs-5 mt-1 text-danger"></i></span>
                                                                    </div>
                                                                    <div className="ms-1 fs-7">Edit</div>
                                                                </div>
                                                            </Link>
                                                        </Dropdown.Item>

                                                        <Dropdown.Item className='px-2 py-1' onClick={() => DeleteModal(type)}>
                                                            <div className='d-flex align-items-center'>
                                                                <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                    <span><i className="fa-solid fa-trash-can fs-5 mt-1 text-danger"></i></span>
                                                                </div>
                                                                <div className="ms-1 fs-7">Delete</div>
                                                            </div>
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {staff.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + staff.length} of {total_entries} entries
                            </span>
                        ) : (
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            {/* Previous Button */}
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                    Previous
                                </button>
                            </li>

                            {/* First Page */}
                            <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                    1
                                </button>
                            </li>

                            {/* Left Ellipsis */}
                            {page > 4 && (
                                <li className="page-item disabled">
                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                </li>
                            )}

                            {/* Pages Around Current */}
                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                .map(p => (
                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                            {p}
                                        </button>
                                    </li>
                                ))}

                            {/* Right Ellipsis */}
                            {page < totalPages - 3 && (
                                <li className="page-item disabled">
                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                </li>
                            )}

                            {/* Last Page */}
                            {totalPages > 1 && (
                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                        {totalPages}
                                    </button>
                                </li>
                            )}

                            {/* Next Button */}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>

                </div>

            </div>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Staff Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Name</label>
                                <input
                                    type='text'
                                    className='form-control'
                                    value={filterName}
                                    onChange={(e) => setFilterName(e.target.value)}
                                    placeholder="Enter Name"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Email</label>
                                <input
                                    type='text'
                                    className='form-control'
                                    value={filterEmail}
                                    onChange={(e) => setFilterEmail(e.target.value)}
                                    placeholder="Enter Email"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Mobile Number</label>
                                <input
                                    type='text'
                                    className='form-control'
                                    value={filterMobile}
                                    onChange={(e) => setFilterMobile(e.target.value)}
                                    placeholder="Enter Mobile Number"
                                />
                            </div>

                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Department</label>
                                <Select
                                    value={departmentOptions.find(option => option.value === filterDepartment)}
                                    onChange={(selected) => setFilterDepartment(selected?.value ?? "all")}
                                    options={departmentOptions}
                                    placeholder="Select Department"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Position</label>
                                <input
                                    type='text'
                                    className='form-control'
                                    value={filterPosition}
                                    onChange={(e) => setFilterPosition(e.target.value)}
                                    placeholder="Enter Position"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={resetFilters}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={fetchStaffData}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default Staff;